import {
  createRxDatabase,
  addRxPlugin,
} from "rxdb"
import type { RxDatabase } from "rxdb"
import { RxDBDevModePlugin } from "rxdb/plugins/dev-mode"
import { RxDBQueryBuilderPlugin } from "rxdb/plugins/query-builder"
import { getRxStorageLoki } from "rxdb/plugins/storage-lokijs"
import { observeNewCollections } from "rxdb-hooks"
import {
  accountInsulinSchema,
  accountMedicationSchema,
  entryTemplateSchema,
  insulinSchema,
  medicationSchema,
  userEntrySchema,
  userEventSchema,
} from "src/schema"
import { CollectionKey } from "src/types"

// eslint-disable-next-line
const LokiIncrementalIndexedDBAdapter = require("lokijs/src/incremental-indexeddb-adapter")

//side effects
addRxPlugin(RxDBQueryBuilderPlugin)
addRxPlugin(observeNewCollections)

// in development run in dev mode
if (process.env?.NODE_ENV === "development") {
  addRxPlugin(RxDBDevModePlugin)
}

export const dbName = "sugarmate_web_app_db_caregiver_4_1"

/*
 * creates a sugarmate database and its collections
 */
export async function createSugarmateRxDatabase(): Promise<RxDatabase> {
  const database = await createRxDatabase({
    name: dbName,
    storage: getRxStorageLoki({
      // eslint-disable-next-line
      adapter: new LokiIncrementalIndexedDBAdapter(),
    }),
    eventReduce: true,
    multiInstance: true,
    ignoreDuplicate: true,
  })

  await database.addCollections({
    [CollectionKey.AccountInsulin]: { schema: accountInsulinSchema },
    [CollectionKey.AccountMedication]: { schema: accountMedicationSchema },
    [CollectionKey.EntryTemplate]: { schema: entryTemplateSchema },
    [CollectionKey.Insulin]: { schema: insulinSchema },
    [CollectionKey.Medication]: { schema: medicationSchema },
    [CollectionKey.UserEntry]: { schema: userEntrySchema },
    [CollectionKey.UserEvent]: { schema: userEventSchema },
  })

  return database
}
